export const GET_GUILDS = {
  prefix: 'GET_GUILDS',
  BEGIN: 'GET_GUILDS_BEGIN',
  SUCCESS: 'GET_GUILDS_SUCCESS',
  FAILURE: 'GET_GUILDS_FAILURE'
}

export const EDIT_GUILD = {
  BEGIN: 'EDIT_GUILD_BEGIN',
  SUCCESS: 'EDIT_GUILD_SUCCESS',
  FAILURE: 'EDIT_GUILD_FAILURE'
}

export const GET_GUILD_BACKUP = {
  BEGIN: 'GET_GUILD_BACKUP_BEGIN',
  SUCCESS: 'GET_GUILD_BACKUP_SUCCESS',
  FAILURE: 'GET_GUILD_BACKUP_FAILURE'
}

export const SET_ACTIVE_GUILD = 'SET_ACTIVE_GUILD'
